import { CircleLayer, LineLayer } from '@trimblemaps/trimblemaps-js';
import { FeatureTypes, MapLayers, MapSources } from '../enums';
import { isVisibleUtil } from '../mapUtils';

/**
 * Creates a layer to display circles on the map for each Point and 'featureType' of 'shipperLaneCenter' in the given map source.
 * Adds the shipper health lane center layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addShipperHealthLaneCenterLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    const visibility = isVisibleUtil(isVisible);

    const layer: CircleLayer = {
        id: MapLayers.shipperHealthLaneCenterLayer,
        type: 'circle',
        source: mapSource,
        layout: {
            visibility,
        },
        paint: {
            'circle-color': ['get', 'color'],
            'circle-opacity': 1.0,
            'circle-radius': 4,
            'circle-stroke-width': 2,
            'circle-stroke-color': ['get', 'strokeColor'],
        },
        filter: ['all',
            ['==', '$type', 'Point'],
            ['==', 'featureType', FeatureTypes.ShipperLaneCenter],
        ],
    };

    if (map.getLayer(MapLayers.shipperHealthLaneCenterLayer) === undefined) {
        map.addLayer(layer);
    }
};

/**
 * Creates a layer to display lines on the map for each LineString and 'featureType' of 'shipperLaneLine' in the given map source.
 * Adds the shipper health lane line layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addShipperHealthLaneLineLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    const visibility = isVisibleUtil(isVisible);

    const layer: LineLayer = {
        id: MapLayers.shipperHealthLaneLineLayer,
        type: 'line',
        source: mapSource,
        layout: {
            'line-join': 'round',
            'line-cap': 'round',
            visibility,
        },
        paint: {
            'line-color': ['get', 'color'],
            'line-width': 6,
            'line-opacity': 1.0,
            'line-offset': 0,
        },
        filter: ['all',
            ['==', '$type', 'LineString'],
            ['==', 'featureType', FeatureTypes.ShipperLaneLine],
        ],
    };

    if (map.getLayer(MapLayers.shipperHealthLaneLineLayer) === undefined) {
        map.addLayer(layer);
    }
};
